(function($) {
    $(function() {
        const urlParameters = new URLSearchParams(window.location.search);
        const linkTokenParam = urlParameters.get('linkToken');

        if (Cookies.get('logged_in')) {
            window.iFrameToken = Cookies.get('operator_token');
            return;
        }

        if (!linkTokenParam && !Cookies.get('logged_in')) {
            Cookies.remove('operator_token');
            return;
        }

        const [userId, ...rest] = linkTokenParam.split('-');

        $.ajax({
            url: '/api/oauth2/linkToken',
            type: 'POST',
            async: false,
            data: {
                userId,
                linkToken: rest.join('-'),
            },
            error: function(error) {
                console.log(error);
                return;
            },
            success: function(response) {
                $('.js-logged-in-fields').removeClass('visible-print');
                const token = response.token;
                Cookies.set('operator_token', token, '365');
                window.iFrameToken = token;
                window.api = API_URL;
            },
        });
    });
})(jQuery);
